export default "__VITE_ASSET__BjlFdYkO__"